import React, { useEffect, useState } from 'react';
import GetDataApi from 'src/common/FetchData/GetDataApi';
import { TOtherIncomeHeadList } from './type/otherIncomeType';
import { Autocomplete, debounce, TextField } from '@mui/material';
import { Controller, Control, FieldValues } from 'react-hook-form';

const SelectOtherHeadList = ({
  control,
  name,
  label,
}: {
  control: Control<FieldValues, any>;
  name: string;
  label: string;
}) => {
  const [filterItem, setFilterItem] = useState({
    name: '',
  });

  let uri = `/api/atab/income-head?CompanyProfileId=1&limit=50`;
  if (filterItem.name) {
    uri += `&name=${filterItem?.name}`;
  }

  const { getData, loading, response } =
    GetDataApi<TOtherIncomeHeadList[]>(uri);

  useEffect(() => {
    (async function () {
      await getData();
    })();
  }, [filterItem.name]);

  const handleInputChange = debounce((value: string, key: string) => {
    setFilterItem((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  }, 2000);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          freeSolo
          id='free-solo-2-demo'
          options={response}
          getOptionLabel={(option: TOtherIncomeHeadList) => option.name || ''}
          onChange={(event, value: TOtherIncomeHeadList) =>
            field.onChange(value?.id || '')
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={label || ''}
              onChange={(e) => handleInputChange(e.target.value, 'name')}
            />
          )}
        />
      )}
    />
  );
};

export default SelectOtherHeadList;
